import { z } from 'zod';

export const RMA_INITIATOR = Object.freeze({
  OPERATOR: 'operator',
  CUSTOMER_SELF_SERVICE: 'customer-self-service',
});

export const RMA_REASON = Object.freeze({
  DAMAGED_ON_ARRIVAL: 'damaged-on-arrival',
  WRONG_ITEM: 'wrong-item',
  WRONG_QUANTITY: 'wrong-quantity',
  QUALITY_DEFECT: 'quality-defect',
  NO_LONGER_NEEDED: 'no-longer-needed',
  DUPLICATE_ORDER: 'duplicate-order',
  WARRANTY_CLAIM: 'warranty-claim',
  RECALL: 'recall',
  OTHER: 'other',
});

export const DISPOSITION = Object.freeze({
  RESTOCK: 'restock',
  REFURBISH: 'refurbish',
  SCRAP: 'scrap',
  DONATE: 'donate',
  HAZMAT_DISPOSAL: 'hazmat-disposal',
  VENDOR_RETURN: 'vendor-return',
});

export const RMA_STATUS = Object.freeze({
  PENDING_REVIEW: 'pending-review',
  AEGIS_PROPOSED: 'aegis-proposed',
  OPERATOR_APPROVED: 'operator-approved',
  RETURN_IN_TRANSIT: 'return-in-transit',
  RECEIVED: 'received',
  DISPOSITIONED: 'dispositioned',
  CREDIT_ISSUED: 'credit-issued',
  CLOSED: 'closed',
  REJECTED: 'rejected',
});

export const RmaInitiator = z.enum(Object.values(RMA_INITIATOR));
export const RmaReason    = z.enum(Object.values(RMA_REASON));
export const Disposition  = z.enum(Object.values(DISPOSITION));
export const RmaStatus    = z.enum(Object.values(RMA_STATUS));

export const RmaLineItem = z.object({
  itemId:       z.string(),
  sku:          z.string(),
  quantity:     z.number().int().positive(),
  serialNumber: z.string().nullable(),
});

export const RmaRequest = z.object({
  id:                          z.string(),
  tenantId:                    z.string(),
  customerId:                  z.string(),
  originalOrderId:             z.string(),
  initiator:                   RmaInitiator,
  initiatedAt:                 z.string(),
  initiatedByUserId:           z.string(),
  reason:                      RmaReason,
  reasonDetail:                z.string(),
  itemsRequested:              z.array(RmaLineItem),
  proposedDisposition:         Disposition.nullable().default(null),
  aegisRecommendationActionId: z.string().nullable().default(null),
  approvedDisposition:         Disposition.nullable().default(null),
  approverUserId:              z.string().nullable().default(null),
  approvedAt:                  z.string().nullable().default(null),
  returnShipmentRef:           z.string().nullable().default(null),
  receivedAt:                  z.string().nullable().default(null),
  creditOrRefundAmountUSD:     z.number().nullable().default(null),
  creditOrRefundEventRef:      z.string().nullable().default(null),
  rootCauseAnalysisRef:        z.string().nullable().default(null),
  status:                      RmaStatus,
  correlationId:               z.string(),
  softDeleted:                 z.boolean().default(false),
});
